import { styled } from "@mui/material/styles";

export const TableWrapperOne = styled("table")(({ theme }) => ({
  borderCollapse: "collapse",
  width: "100%",

  "& caption": {
    textAlign: "left",
    fontWeight: "bold",
    padding: "0 5px 5px 0",
    fontSize: "1rem",
    color: theme.palette.info.dark,
  },
  "& th": {
    fontWeight: 600,
  },
  "&, th, td": {
    border: `1px solid ${theme.palette.grey[300]}`,
  },
  "& th, & td": {
    padding: "5px 10px",
    fontSize: "0.95rem",
  },
  "& td": {
    textAlign: "center",
  },
}));
